<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					zIndex: {
						name: 'zIndex',
						defaultValue: '',
						labelDesc: 'zIndex',
						callback: function () {
							vm.resources.zIndex.defaultValue = this.value;
							vm.element.internal_config.zIndex = this.value;

						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '100',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						},
					},
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.borderRadius = value;
						},
					},
					boxShadow: {
						name: 'boxShadow',
						defaultValue: '0 0 0 0 black initial',
						min: '0',
						max: '50',
						labelDesc: 'boxShadow',
						callback: function () {

							let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

							vm.resources.boxShadow.defaultValue = value;
							vm.element.internal_config.boxShadow = value;
						},
					},
					backgroundColor: {
						name: 'backgroundColor',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color',
						callback: function () {
							vm.resources.backgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.backgroundColor = this.colorValue;
						},
					},
					// height: {
					// 	name: 'height',
					// 	defaultValue: '300',
					// 	min: '50',
					// 	max: '1000',
					// 	labelDesc: 'height',
					// 	callback: function () {
					// 		vm.resources.height.defaultValue = this.value;
					// 		vm.element.internal_config.height = this.value + 'px';
					// 	},
					// },
					itemMenuTextStyle: {
						name: 'itemMenuTextStyle',
						defaultFamily: '',
						defaultSize: '',
						defaultColor: '',
						defaultAlign: '',
						defaultWeight: '',
						defaultStyle: '',
						labelDesc: 'itemMenuTextStyle',
						callback: function () {

							vm.resources.itemMenuTextStyle.defaultFamily = this.family;
							vm.element.internal_config.btnStyle.family = this.family;

							vm.resources.itemMenuTextStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.btnStyle.size = this.size + 'px';

							vm.resources.itemMenuTextStyle.defaultColor = this.color;
							vm.element.internal_config.btnStyle.color = this.color;

							vm.resources.itemMenuTextStyle.defaultAlign = this.align;
							vm.element.internal_config.btnStyle.align = this.align;

							vm.resources.itemMenuTextStyle.defaultWeight = this.weight;
							vm.element.internal_config.btnStyle.weight = this.weight;

							vm.resources.itemMenuTextStyle.defaultStyle = this.style;
							vm.element.internal_config.btnStyle.style = this.style;

						},
					},
					itemMenuSubTextStyle: {
						name: 'itemMenuSubTextStyle',
						defaultFamily: '',
						defaultSize: '',
						defaultColor: '',
						defaultAlign: '',
						defaultWeight: '',
						defaultStyle: '',
						labelDesc: 'itemMenuSubTextStyle',
						callback: function () {

							vm.resources.itemMenuSubTextStyle.defaultFamily = this.family;
							vm.element.internal_config.subStyle.family = this.family;

							vm.resources.itemMenuSubTextStyle.defaultSize = this.size + 'px';
							vm.element.internal_config.subStyle.size = this.size + 'px';

							vm.resources.itemMenuSubTextStyle.defaultColor = this.color;
							vm.element.internal_config.subStyle.color = this.color;

							vm.resources.itemMenuSubTextStyle.defaultAlign = this.align;
							vm.element.internal_config.subStyle.align = this.align;

							vm.resources.itemMenuSubTextStyle.defaultWeight = this.weight;
							vm.element.internal_config.subStyle.weight = this.weight;

							vm.resources.itemMenuSubTextStyle.defaultStyle = this.style;
							vm.element.internal_config.subStyle.style = this.style;

						},
					},
					btnStyleBackgroundColor: {
						name: 'btnStyleBackgroundColor',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color',
						callback: function () {
							vm.resources.btnStyleBackgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.btnStyle.backgroundColor = this.colorValue;
						},
					},
					btnStyleBackgroundColorHover: {
						name: 'btnStyleBackgroundColorHover',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color-hover',
						callback: function () {
							vm.resources.btnStyleBackgroundColorHover.defaultValue = this.colorValue;
							vm.element.internal_config.btnStyle.backgroundColorHover = this.colorValue;
						},
					},
					btnStyleBackgroundColorActive: {
						name: 'btnStyleBackgroundColorActive',
						defaultValue: '#ffffff',
						labelDesc: 'bg-color-active',
						callback: function () {
							vm.resources.btnStyleBackgroundColorActive.defaultValue = this.colorValue;
							vm.element.internal_config.btnStyle.backgroundColorActive = this.colorValue;
						},
					},
					btnSubStyleBackgroundColor: {
						name: 'btnSubStyleBackgroundColor',
						defaultValue: '#ffffff',
						labelDesc: 'sub-bg-color',
						callback: function () {
							vm.resources.btnSubStyleBackgroundColor.defaultValue = this.colorValue;
							vm.element.internal_config.subStyle.backgroundColor = this.colorValue;
						},
					},
					btnSubStyleBackgroundColorHover: {
						name: 'btnSubStyleBackgroundColorHover',
						defaultValue: '#ffffff',
						labelDesc: 'sub-bg-color-hover',
						callback: function () {
							vm.resources.btnSubStyleBackgroundColorHover.defaultValue = this.colorValue;
							vm.element.internal_config.subStyle.backgroundColorHover = this.colorValue;
						},
					},
					btnSubStyleBackgroundColorActive: {
						name: 'btnSubStyleBackgroundColorActive',
						defaultValue: '#ffffff',
						labelDesc: 'sub-bg-color-active',
						callback: function () {
							vm.resources.btnSubStyleBackgroundColorActive.defaultValue = this.colorValue;
							vm.element.internal_config.subStyle.backgroundColorActive = this.colorValue;
						},
					},
				},
			}
		},
		methods: {
			setValuesData(data) {
				this.element = data;

				this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
				this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
				this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
				this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

				this.resources.border.defaultValue = data.internal_config.border;
				this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
				this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;

				this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;

				// this.resources.height.defaultValue = parseInt(data.internal_config.height);

				this.resources.itemMenuTextStyle.defaultFamily = data.internal_config.btnStyle.family;
				this.resources.itemMenuTextStyle.defaultSize = data.internal_config.btnStyle.size;
				this.resources.itemMenuTextStyle.defaultColor = data.internal_config.btnStyle.color;
				this.resources.itemMenuTextStyle.defaultAlign = data.internal_config.btnStyle.align;
				this.resources.itemMenuTextStyle.defaultWeight = data.internal_config.btnStyle.weight;
				this.resources.itemMenuTextStyle.defaultStyle = data.internal_config.btnStyle.style;

				this.resources.itemMenuSubTextStyle.defaultFamily = data.internal_config.subStyle.family;
				this.resources.itemMenuSubTextStyle.defaultSize = data.internal_config.subStyle.size;
				this.resources.itemMenuSubTextStyle.defaultColor = data.internal_config.subStyle.color;
				this.resources.itemMenuSubTextStyle.defaultAlign = data.internal_config.subStyle.align;
				this.resources.itemMenuSubTextStyle.defaultWeight = data.internal_config.subStyle.weight;
				this.resources.itemMenuSubTextStyle.defaultStyle = data.internal_config.subStyle.style;

				this.resources.btnStyleBackgroundColor.defaultValue = data.internal_config.btnStyle.backgroundColor;
				this.resources.btnStyleBackgroundColorHover.defaultValue = data.internal_config.btnStyle.backgroundColorHover;
				this.resources.btnStyleBackgroundColorActive.defaultValue = data.internal_config.btnStyle.backgroundColorActive;

				this.resources.btnSubStyleBackgroundColor.defaultValue = data.internal_config.subStyle.backgroundColor;
				this.resources.btnSubStyleBackgroundColorHover.defaultValue = data.internal_config.subStyle.backgroundColorHover;
				this.resources.btnSubStyleBackgroundColorActive.defaultValue = data.internal_config.subStyle.backgroundColorActive;

			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>
